import { render, staticRenderFns } from "./BusinessMenu.vue?vue&type=template&id=d6db85aa&scoped=true&"
import script from "./BusinessMenu.vue?vue&type=script&lang=ts&"
export * from "./BusinessMenu.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessMenu.vue?vue&type=style&index=0&id=d6db85aa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6db85aa",
  null
  
)

export default component.exports